/**
 * Vantagepoint hire dates arrive as date-only ISO strings ("YYYY-MM-DD"), which
 * `new Date()` parses as UTC midnight. Reading that back with local getters
 * (getMonth/getFullYear/toLocaleDateString) rolls the calendar date backward
 * in any timezone behind UTC — e.g. a July 1 hire date shows as June 30 in
 * US timezones. This re-anchors the parsed UTC calendar date onto local
 * midnight so every local getter downstream reads the correct date.
 */
export function parseHireDate(value) {
  if (!value) return null;
  const utc = new Date(value);
  if (Number.isNaN(utc.getTime())) return null;
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
}
